<template>
  <div class="account-list-wrap">
    <div class="account-list" v-for="(item,index) in accountList">
      <div class="list-info">
        <p class="name">{{item.accountName}}
          <span class="account-number">【ID:{{item.accountKey}}】</span>
        </p>
        <p>{{item.brief}}</p>
        <p v-if="item.type !=12 ">粉丝数 <span>{{item.fansCount}}人</span></p>
      </div>
      <div>
        <button v-if="!item.status" class="button is-success" @click="subscribe(1,item,index)">订阅</button>
        <button v-else="" class="button is-danger" @click="subscribe(0,item,index)">取消订阅</button>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">

  export default{
    data(){
      return{

      }
    },
    props:{
      selectedIndex:Number,
      accountList:{
        type:[Object,Array]
      }
    },
    methods:{
      subscribe(type,obj,index){
        if(type == 1){
          this.$emit("subscribr-click",obj,index)
        }else{
          this.$emit("cancel-subscribe-click",obj,index)
        }
      }
    }
  }
</script>
<style lang="less">
  .account-list-wrap{
    .account-list{
      margin: 20px 0;
      display: flex;
      .name{
        color: #222324;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 5px;
      }
      .list-info{
        width: 90%;
      }
    }
    .account-number{
      font-size: 14px;
      color: #42afe3;
    }
  }
</style>
